export enum FeedbackReason {
  notWithinBudget = "not_within_budget",
  missingFeatures = "missing_features",
  noTimeToTest = "no_time_to_test",
  other = "other"
}

export type FeedbackFormData = {
  reasons: Set<FeedbackReason>
  missingFeaturesText: string
  otherText: string
}

export type FeedbackSubmitPayload = {
  reasons: Array<FeedbackReason>
  missingFeaturesText?: string
  otherText?: string
}

export type StartKycResponse = {
  verification_url: string
  reference: string
}

export type KycStatus = "pending" | "cancelled" | "timeout" | "accepted" | "declined" | "review_pending"

export type KycState = {
  status: KycStatus | null
  verification_url: string | null
}
